var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({staticClass:"bounding-box",class:{
    'bounding-box--active': _vm.highlighted,
    [`bounding-box-${_vm.label}`]: true,
  },style:(_vm.boundingBoxStyle)},_vm.$listeners),[_c('span',{staticClass:"bounding-box__label"},[_vm._t("default",function(){return [_vm._v("\n      "+_vm._s(_vm.getFormattedLabel(_vm.label))+"\n    ")]})],2),_vm._v(" "),_vm._t("action")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }